// Section 8: Forager. 1.4 food and 0.3 fibre, seasonal (Section 4); the nth forager yields
// 0.9^(n-1). Basket 1.2x; 3% injury, 1% animal attack. Constants: config.jobs.forager.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { powInt } from '../../core/math';
import { memoByState } from '../../core/memo';
import { isWorking, peopleSorted } from '../../core/queries';
import { alwaysEligible, jobOutput, produced } from '../../core/content-helpers';
import { defineJob } from '../../core/registry';

export function forager(config: Config) {
  const c = config.jobs.forager;

  return defineJob({
    id: 'forager',
    label: 'Forager',
    section: 'S8',
    heavy: false,
    output: { kind: 'stock', resource: 'food' },
    baseYield: c.yield,
    toolFactor: c.toolFactor,
    toolWear: 0,
    risks: { injury: c.injury, animal: c.animal },
    riskIllness: null,
    requiresBuilding: null,
    minStrength: 0,
    modifierTargets: ['output'],
    modifierKeys: { output: ['forager'] },
    modifiers: jobOutput('forager', (ctx, p) => {
      const crew = memoByState(ctx.state, 'forager-crew', () =>
        peopleSorted(ctx.state)
          .filter((q) => q.job === 'forager' && isWorking(q))
          .map((q) => q.id),
      );
      const n = crew.indexOf(p.id);
      return n > 0
        ? [mod.mul('job:forager', powInt(c.diminishing, n), `forager ${n + 1} of ${crew.length}`)]
        : [];
    }),
    produce(_ctx, _worker, output) {
      if (output <= 0) return [];
      return [produced('food', output), produced('fibre', (c.fibre * output) / c.yield)];
    },
    eligible: alwaysEligible,
  });
}
